// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"8":"editor","623":"tree","671":"verbose"}[chunkId] || chunkId) + "-legacy." + {"8":"71a33da7","233":"8912ac39","414":"855759e9","579":"7e82a38e","623":"0babda97","671":"a6a773ad","940":"e77eb47a"}[chunkId] + ".js";
};